import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import reportWebVitals from './reportWebVitals';
import { ENV_URL } from './Essentials/variables';
import NotificationProvider from "./Components/Notifications/NotificationProvider";
const root = ReactDOM.createRoot(document.getElementById('root'));

if(ENV_URL!=='https://dev.msilruralmaps.com/'){
  console.log=()=>{}
}
root.render(
  <Provider store={store}>
    <NotificationProvider>
    <App />
    </NotificationProvider>
  </Provider>
);

